/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BusinessIntelligenceBiReportingComponent } from './BusinessIntelligenceBiReportingComponent'
import type { GlobalAddressComponent } from './GlobalAddressComponent'
import type { ProfessionalAboutComponent } from './ProfessionalAboutComponent'
import type { ProfessionalExperienceComponent } from './ProfessionalExperienceComponent'
import type { ProfessionalUpdateEmailComponent } from './ProfessionalUpdateEmailComponent'
import type { ProfilingFilterTagComponent } from './ProfilingFilterTagComponent'
export type ProfessionalRequest = {
  data: {
    status: ProfessionalRequest.status
    address?: GlobalAddressComponent
    about?: ProfessionalAboutComponent
    experiences?: Array<ProfessionalExperienceComponent>
    tags?: Array<number | string>
    interests?: Array<number | string>
    user?: number | string
    maximumRadiusKm?: number
    interactions?: Array<number | string>
    lastUpdateEmail?: ProfessionalUpdateEmailComponent
    appointments?: Array<number | string>
    placements?: Array<number | string>
    candidate?: number | string
    matchings?: Array<number | string>
    filterTags?: Array<ProfilingFilterTagComponent>
    biNotes?: string
    finishedOnboarding?: boolean
    businessIntelligence?: BusinessIntelligenceBiReportingComponent
    messages?: Array<number | string>
    talentpools?: Array<number | string>
    referredBy?: Array<number | string>
    sentReferrals?: Array<number | string>
  }
}
export namespace ProfessionalRequest {
  export enum status {
    ORIENTATING = 'orientating',
    ACTIVE = 'active',
    INACTIVE = 'inactive',
  }
}
